import { Breadcrumbs } from "../components/Breadcrumbs";
import { useSeo } from "../lib/seo";

export default function Disclaimer() {
  useSeo({
    title: "Disclaimer | ProfitMigo",
    description: "ProfitMigo calculators provide estimates only. Actual marketplace fees, taxes and returns vary and can change. Verify important financial decisions independently.",
    path: "/disclaimer",
  });

  return (
    <div className="mx-auto max-w-3xl px-4 py-8 sm:px-6">
      <Breadcrumbs items={[{ label: "Home", to: "/" }, { label: "Disclaimer" }]} />
      <h1 className="font-display text-4xl font-bold tracking-tight sm:text-5xl">Disclaimer</h1>
      <div className="mt-6 space-y-4 text-base leading-relaxed text-foreground/80">
        <p>The information and results provided by ProfitMigo calculators are <strong>estimates for general guidance only</strong> and do not constitute financial, tax or accounting advice.</p>
        <ul className="list-disc space-y-2 pl-6">
          <li>Calculations are based only on the values you enter; costs you omit will not be reflected.</li>
          <li>Marketplace fees, shipping rates and commissions can change and vary by category and account.</li>
          <li>Tax treatment (including GST and input credits) varies by business and jurisdiction.</li>
          <li>You should verify important financial decisions with the relevant marketplace and a qualified professional.</li>
        </ul>
        <p>We do not guarantee any specific profit, income, ranking or business outcome.</p>
      </div>
    </div>
  );
}
